<template>
  <aside class="app-menu">
    <el-menu
      :collapse="true"
      :default-active="currentRouteName"
    >
      <div class="app-menu__logo">
        <img
          src="@/assets/svg/RIK Root.svg"
          alt="Logo"
        />
      </div>

      <AppSubMenu
        v-for="(route, index) in filteredRoutes"
        :key="index"
        :route="route"
      />
    </el-menu>
  </aside>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { routes } from '@/core/utils/router'
import { useRoute } from 'vue-router/composables'
import AppSubMenu from './AppSubMenu.vue'
import { useStore } from '../utils/useStore'

export default defineComponent({
  name: 'AppMenu',

  components: {
    AppSubMenu,
  },

  setup() {
    const store = useStore()
    const route = useRoute()

    const parkMode = computed(() => {
      return store.state.globalSettings.settingsData.mode
    })

    const currentRouteName = computed(() => {
      return route.name
    })

    const filteredRoutes = computed(() => {
      return routes.filter((e) => {
        const isCorrectParkMode =
          e.meta.parkMode === undefined || parkMode.value === e.meta.parkMode

        return isCorrectParkMode
      })
    })

    return {
      filteredRoutes,
      currentRouteName,
    }
  },
})
</script>

<style lang="scss">
body div.el-menu--vertical {
  left: 80px !important;
}

ul.el-menu--popup {
  padding: 0;
  border-radius: 16px;
  margin: 0;
  overflow: hidden;
}

.app-menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 70px;
  z-index: 1000;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;

  .el-menu {
    width: inherit;
    height: 100%;
    background-color: #f1f0ed;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__logo {
    width: 100%;
    padding: 15px 10px 5px 15px;

    img {
      width: 100%;
    }
  }
}
</style>
